var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dj-media-upload-header"},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":_vm.uploadHandle}},[_c('dj-media-label',{attrs:{"media":"upload","media-size":"15px","label":_vm.uploadName},on:{"click":_vm.uploadHandle}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }